import type { ReactFlowState } from '@xyflow/react';

/** Below this zoom a node draws as a plain block in its kind's colour, and only the tree edges are drawn. */
export const COMPACT_ZOOM = 0.45;

/** Below this zoom (and down to `COMPACT_ZOOM`) a card shows its title line only, so an overview reads as names. */
export const SUBTITLE_ZOOM = 0.6;

/** How much of a card shows: all of it, its title line, or a block in its kind's colour. */
export type ZoomDetail = 'full' | 'titleOnly' | 'compact';

export const zoomDetail = (zoom: number): ZoomDetail =>
  zoom < COMPACT_ZOOM ? 'compact' : zoom < SUBTITLE_ZOOM ? 'titleOnly' : 'full';

/**
 * The cards' detail at the canvas zoom. A string selector, so a card renders again only when the zoom crosses a
 * threshold, never on a pan or a zoom step that stays within one band.
 */
export const selectZoomDetail = (s: ReactFlowState) => zoomDetail(s.transform[2]);

/** The canvas is zoomed out to an overview (below `COMPACT_ZOOM`); a boolean selector, as `selectZoomDetail`. */
export const selectOverview = (s: ReactFlowState) => zoomDetail(s.transform[2]) === 'compact';
